/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2024-02-04 10:04:45
 * @LastEditors: sueRimn
 * @LastEditTime: 2024-02-04 14:38:25
 */
import { message } from 'antd'
import type { Effect } from 'umi'
import {
  createDiscuss,
  updateDiscuss,
  deleteDiscuss,
  likeDiscuss,
  unlikeDiscuss,
  getCommentList
} from '@/services/project/comment'

interface StateType {}

export interface LogModelType {
  namespace: string
  state: StateType
  effects: {
    fetchCreateDiscuss: Effect
    fetchUpdateDiscuss: Effect
    fetchDeleteDiscuss: Effect
    fetchLikeDiscuss: Effect
    fetchUnlikeDiscuss: Effect
    fetchCommentList: Effect
  }
  reducers: {}
}

const LogListModel: LogModelType = {
  namespace: 'workbenchLogList',

  state: {},

  effects: {
    *fetchCommentList({ payload }, { call, put }) {
      const res = yield call(getCommentList, payload)
      if (res.code === 0) {
        return Promise.resolve({
          list: res.data.list,
          total: res.data.total
        })
      }
      return Promise.reject([])
    },
    *fetchCreateDiscuss({ payload }, { call, put }) {
      const res = yield call(createDiscuss, { discuss: payload })
      if (res.code === 0) {
        message.success('发布成功')
        return Promise.resolve()
      }
      return Promise.reject()
    },
    *fetchUpdateDiscuss({ payload }, { call, put }) {
      const res = yield call(updateDiscuss, { discuss: payload })
      if (res.code === 0) {
        message.success('编辑成功')
        return Promise.resolve()
      }
      return Promise.reject()
    },
    *fetchDeleteDiscuss({ payload }, { call, put }) {
      const res = yield call(deleteDiscuss, payload)
      if (res.code === 0) {
        message.success('删除成功')
        return Promise.resolve()
      }
      return Promise.reject()
    },
    *fetchLikeDiscuss({ payload }, { call, put }) {
      const res = yield call(likeDiscuss, payload)
      if (res.code === 0) {
        return Promise.resolve()
      }
      return Promise.reject()
    },
    *fetchUnlikeDiscuss({ payload }, { call, put }) {
      const res = yield call(unlikeDiscuss, payload)
      if (res.code === 0) {
        return Promise.resolve()
      }
      return Promise.reject()
    }
  },

  reducers: {}
}

export default LogListModel
